import angular from 'angular';
import template from './mobile-patient-actions.html';
class GroupCallMobilePatientActionsController {
    $onInit() {
        if (this.stream.type === 'screen') {
            this.name = this.username + "'s screen";
        }
        else {
            this.name = this.username;
        }
    }
}
const groupCallMobilePatientActions = {
    template,
    bindings: {
        stream: '<',
        isInGroupCall: '<',
        username: '<',
        disabled: '<',
        onToggleAudio: '&',
        onCallEnd: '&',
        onTogglePin: '&',
        isPinned: '<',
    },
    controller: GroupCallMobilePatientActionsController,
};
export default angular
    .module('doxy.videoChat.callFrames.participantVideoFrame.participantVideoFrameFull.actions.groupCall.mobilePatientActions', [])
    // participant-group-call-mobile-patient-actions
    .component('participantGroupCallMobilePatientActions', groupCallMobilePatientActions).name;
